var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "mx-3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8094 20.3027L14.7082 13.2016C15.8102 11.777 16.4062 10.0352 16.4062 8.20312C16.4062 6.01016 15.5504 3.95391 14.0027 2.40352C12.4551 0.853125 10.3934 0 8.20312 0C6.01289 0 3.95117 0.855859 2.40352 2.40352C0.853125 3.95117 0 6.01016 0 8.20312C0 10.3934 0.855859 12.4551 2.40352 14.0027C3.95117 15.5531 6.01016 16.4062 8.20312 16.4062C10.0352 16.4062 11.7742 15.8102 13.1988 14.7109L20.3 21.8094C20.3208 21.8302 20.3455 21.8467 20.3728 21.858C20.4 21.8693 20.4291 21.8751 20.4586 21.8751C20.4881 21.8751 20.5172 21.8693 20.5444 21.858C20.5716 21.8467 20.5964 21.8302 20.6172 21.8094L21.8094 20.6199C21.8302 20.5991 21.8467 20.5744 21.858 20.5472C21.8693 20.52 21.8751 20.4908 21.8751 20.4613C21.8751 20.4319 21.8693 20.4027 21.858 20.3755C21.8467 20.3483 21.8302 20.3236 21.8094 20.3027ZM12.5344 12.5344C11.375 13.691 9.83828 14.3281 8.20312 14.3281C6.56797 14.3281 5.03125 13.691 3.87188 12.5344C2.71523 11.375 2.07812 9.83828 2.07812 8.20312C2.07812 6.56797 2.71523 5.02852 3.87188 3.87188C5.03125 2.71523 6.56797 2.07812 8.20312 2.07812C9.83828 2.07812 11.3777 2.7125 12.5344 3.87188C13.691 5.03125 14.3281 6.56797 14.3281 8.20312C14.3281 9.83828 13.691 11.3777 12.5344 12.5344Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ab27167c.svg";
export { ForwardRef as ReactComponent };